import React, { useState, useEffect } from "react";
import img2 from "../image for geo project/2.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { IoPricetagOutline } from "react-icons/io5";
import { Swiper, SwiperSlide } from "swiper/react";
import { MdOutlineBedroomParent } from "react-icons/md";
import { TbContract } from "react-icons/tb";
import { FiLayout } from "react-icons/fi";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { LuBath } from "react-icons/lu";
import { TfiRulerAlt } from "react-icons/tfi";
import { FaMobileAlt } from "react-icons/fa";
import { AiOutlineFormatPainter } from "react-icons/ai";
import { LuTreePalm } from "react-icons/lu";
import { MdBalcony } from "react-icons/md";
import { GrElevator } from "react-icons/gr";
import { MdOutlinePool } from "react-icons/md";
import { RiParkingBoxLine } from "react-icons/ri";
import { HiOutlineHomeModern } from "react-icons/hi2";
import { TbSolarElectricity } from "react-icons/tb";
import { RiWaterFlashLine } from "react-icons/ri";
import { PiElevatorDuotone } from "react-icons/pi";
import { TbRulerMeasure } from "react-icons/tb";
import { TbRulerMeasure2 } from "react-icons/tb";
import { FaCheckCircle } from "react-icons/fa";
import { IoCloseCircle } from "react-icons/io5";
import { PiSolarPanel } from "react-icons/pi";
import { GiHotSurface } from "react-icons/gi";
import { FaPersonShelter } from "react-icons/fa6";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import { GiDuration } from "react-icons/gi";
import { LiaCompassSolid } from "react-icons/lia";

import ReactPlayer from 'react-player'
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "./styles.css";

// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { MdOutlineSlowMotionVideo } from "react-icons/md";
import "react-circular-progressbar/dist/styles.css";
import { RiSofaLine } from "react-icons/ri";

import { useTranslation } from "react-i18next";
import { useFetchData } from "../hooks/useFetchData";
import { TestLanguage } from "../hooks/testLanguage";
import { Grid, IconButton, Modal, Tooltip, Typography } from "@mui/material";
import { DeleteIcon } from "lucide-react";
import { PiElevator } from "react-icons/pi";
import { FaRegCheckCircle } from "react-icons/fa";
import { PiPark } from "react-icons/pi";
import { IoIosCall } from "react-icons/io";
import { RiWhatsappFill } from "react-icons/ri";
import { TfiEmail } from "react-icons/tfi";

const Drawer2 = ({ point, isOpen, onClose, children ,selectedPoint}) => {
  console.log("hhhhhhhhhhh", point, selectedPoint);
  
  const url = `${process.env.REACT_APP_API_URL}unitsbyid/${point}`;
  const url2 = `${process.env.REACT_APP_API_URL}projects/${point}`;
  const { data, isLoading, error } = useFetchData(url , "drawer2");
  const [showDiv, setShowDiv] = useState(false);
console.log("c",data);


  const videoList = data?.data?.medias?.filter((media) => media?.type === "video") || [];
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleVideoClick = (video) => {
    setSelectedVideo("http://3dfinal.tanaghomtech.com/storage/app/public/" + video?.link);
  };


  const handleClick = () => {

    const id = data?.data?.id
    setShowDiv((prev) => !prev);
    const formdata = new FormData()
    formdata.append("id", id)
    if (!showDiv) {
      const postData = async () => {
        const response = await fetch('https://3dfinal.tanaghomtech.com/public/api/unitview', {
          method: 'POST',
          body: formdata,
        });

        if (!response.ok) {
          throw new Error('Failed to post data');
        }

        return response.json();
      };
      postData();
    }

  };
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const { t } = useTranslation();


  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);

  };

  const handleClose = () => {
    console.log("Modal close clicked");
    setOpen(false);
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };
  const cardStyle = {
    width: "350px",
    height: "250px",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    fontFamily: "Oswald,Cairo, sans-serif",
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "10px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "5px",
  };
  const iconData = [
    { label: t("drawerUnit.elevator"), icon: PiElevator, colname: "elevator" },
    {
      label: t("drawerUnit.elevator2"),
      icon: PiElevatorDuotone,
      colname: "solar_elevator",
    },
    { label: t("drawerUnit.balcony"), icon: MdBalcony, colname: "garden" },
    { label: t("drawerUnit.pool"), icon: MdOutlinePool, colname: "parking" },
    {
      label: t("drawerUnit.parking"),
      icon: RiParkingBoxLine,
      colname: "solar_water",
    },
    {
      label: t("drawerUnit.solar_water"),
      icon: HiOutlineHomeModern,
      colname: "solar_electricity",
    },
    {
      label: t("drawerUnit.solar_electricity"),
      icon: TbSolarElectricity,
      colname: "pool",
    },
    {
      label: t("drawerUnit.terrace"),
      icon: RiWaterFlashLine,
      colname: "balcony",
    },
    {
      label: t("drawerUnit.garden"),
      icon: PiElevatorDuotone,
      colname: "terrace",
    },
  ];
  const iconStyle = {
    fontSize: "60px",
    backgroundColor: "#f3efee",
    padding: "10px",
    borderRadius: "50%",
    margin: "5px",
    color: "#000",
  };

  const labelStyle = {
    fontSize: "20px",
    fontWeight: "bold",
    marginTop: "8px",
  };

  const valueStyle = {
    fontSize: "16px",
    color: "gray",
    marginTop: "4px",
    direction: `${t("directions.dir")}`,
  };

  var listunits = [
    {
      type: "1BD",
      number: "101",
      image: "images/2.svg",
    },
    {
      type: "2bd",
      number: "102",
    },
  ];

  const direction = localStorage.getItem("lang") === "ar" ? "rtl" : "ltr";
  //   const videoList = data?.data?.medias?.filter((media) => media?.type === "video") || [];
  //   const [selectedVideo, setSelectedVideo] = useState(
  //     videoList.forEach((video, index) => {

  //   console.log(`Video ${index}:`, video);
  // })




  console.log("videoList[0]" + videoList[0]);
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: isOpen ? 0 : "-700px",
        width: "700px",
        height: "100%",
        backgroundColor: "#fff",
        boxShadow: "-2px 0 5px rgba(0,0,0,0.3)",
        transition: "right 0.5s ease-in-out",
        zIndex: 1000,
        padding: "20px",
        overflowY: "auto",
        fontFamily: "Oswald,Cairo, sans-serif",
        fontWeight: "bolder",
      }}
    >
      <a style={{ cursor: "pointer" }} onClick={onClose}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          fill="#232324"
          class="bi bi-x-circle-fill"
          viewBox="0 0 16 16"
        >
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
        </svg>
      </a>
      {data?.data?.post?.id && (
        <Grid spacing={2} sx={{ direction: direction }}>
          {/* <Grid item xs={6}>
            <Typography
              variant="h2"
              sx={{
                backgroundColor: "#FFF1CA",
                padding: "30px",
                borderRadius: "50%",
                width: "100px",
                height: "100px",

                fontWeight: "bold",
              }}
            >
              {data.data.post.post_reference}
            </Typography>
          </Grid> */}

          <Grid item xs={6}>
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
              }}
            >
              {TestLanguage(data?.data.offertype, "name")}{" "}
              {TestLanguage(data?.data.status, "name")}
            </Typography>
          </Grid>
        </Grid>
      )}

      <Swiper
        style={{
          "--swiper-navigation-color": "#fff",
          "--swiper-pagination-color": "#fff",
          marginTop: "16px",
        }}
        loop={true}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
        {data?.images?.map((img, idx) => (
          <SwiperSlide>
            <img
              src={`http://3dfinal.tanaghomtech.com/storage/app/public/${img.link}`}
              style={{ height: "450px", borderRadius: "16px" }}
              className="w-100"
              alt={`Slide ${idx}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        loop={true}
        spaceBetween={10}
        slidesPerView={8}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
        {data?.images?.map((img, idx) => (
          <SwiperSlide>
            <img
              src={`http://3dfinal.tanaghomtech.com/storage/app/public/${img.link}`}
              style={{ height: "80px", borderRadius: "8px" }}
              className="w-100"
              alt={`Slide ${idx}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div
        style={{
          fontFamily: "Oswald,Cairo, sans-serif",
          direction: direction,
          fontWeight: "bolder",
        }}
      >
        {children}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          direction: direction,
          fontWeight: "bolder",
        }}
      >
        <FontAwesomeIcon icon={faLocationDot} style={{ margin: "5px" }} />
        <h5>
          {TestLanguage(data?.data?.city, "name")} {" - "}
          {TestLanguage(data?.data?.region, "name")}{" - "}
          {TestLanguage(data?.data, "address")}
        </h5>
      </div>

      <div className="row">
        <h3
          style={{
            fontFamily: "Oswald,Cairo, sans-serif",
            marginTop: "50px",
            marginBottom: "20px",
            fontWeight: "bolder",
            direction: direction,
          }}
        >
          {t("drawerUnit.details")}
        </h3>
      </div>

      <div className="row animate-bottom2">
        <div style={{ display: "flex", alignItems: "center" }}>
          {data?.data?.total_area && (
            <div style={cardStyle}>
              <TbRulerMeasure2 style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.area")}</div>
              <div style={valueStyle}>
                {data?.data?.total_area} {t("drawerUnit.meter")} <sup>2</sup>{" "}
              </div>
            </div>
          )}
          {data?.data?.net_area && (
            <div style={cardStyle}>
              <TbRulerMeasure style={iconStyle} />

              <div style={labelStyle}>{t("drawerUnit.netarea")}</div>
              <div style={valueStyle}>
                {data?.data?.net_area} {t("drawerUnit.meter")} <sup>2</sup>
              </div>
            </div>
          )}
          {data?.data?.floor_number && (
            <div style={cardStyle}>
              <HiOutlineBuildingOffice2 style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.floors")}</div>
              <div style={valueStyle}>{data?.data?.floor_number}</div>
            </div>
          )}
          {data?.data?.price && (
            <div style={cardStyle}>
              <IoPricetagOutline style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.Price")}</div>
              <div style={valueStyle}>{data?.data?.price}$</div>
            </div>
          )}
          {data?.data?.rooms_count && (
            <div style={cardStyle}>
              <MdOutlineBedroomParent style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.Rooms")}</div>
              <div style={valueStyle}>{data?.data?.rooms_count}</div>
            </div>
          )}
        </div>
      </div>
      <div className="row animate-bottom2">
        <div style={{ display: "flex", alignItems: "center" }}>
          {data?.data?.bath_count && (
            <div style={cardStyle}>
              <LuBath style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.bathrooms")}</div>
              <div style={valueStyle}>{data?.data?.bath_count}</div>
            </div>
          )}
          {data?.data?.direction && (
            <div style={cardStyle}>
              <LiaCompassSolid style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.direction")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.direction, "name")}
              </div>
            </div>
          )}
          {data?.data?.contract && (
            <div style={cardStyle}>
              <TbContract style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.contract")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.contract, "name")}{" "}
              </div>
            </div>
          )}
          {data?.data?.offertype && (
            <div style={cardStyle}>
              <FiLayout style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.type")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.offertype, "name")}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="row"></div>
      <div className="row animate-bottom2">
        <div style={{ display: "flex", alignItems: "center" }}>
          {data?.data?.furnishing && (
            <div style={cardStyle}>
              <RiSofaLine style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.fur")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data.furnishing, "name")}
              </div>
            </div>
          )}
          {data?.data?.condition && (
            <div style={cardStyle}>
              <AiOutlineFormatPainter style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.condition")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.condition, "name")}
              </div>
            </div>
          )}
          {data?.data?.rentduration && (
            <div style={cardStyle}>
              <GiDuration style={iconStyle} />
              <div style={labelStyle}>{t("AddUnit.rentduration")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data.rentduration, "name")}
              </div>
            </div>
          )}
          {data?.data?.post?.seller && (
            <div style={cardStyle}>
              <FaPersonShelter style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.sellertype")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.post.seller, "name")}
              </div>
            </div>
          )}
        </div>
      </div>
      <h3
        style={{
          fontFamily: "Oswald,Cairo, sans-serif",
          marginTop: "50px",
          marginBottom: "20px",
          fontWeight: "bolder",
          direction: direction,
        }}
      >
        {t("drawerUnit.detailsexpress")}
      </h3>
      <Grid sx={{ direction: t("directions.dir") }} container spacing={2}>
        <Grid size={4} item>
          <PiElevator size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{iconData[0].label}</span>{" "}
          {data?.data?.elevator ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <PiElevatorDuotone size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{iconData[1].label}</span>{" "}
          {data?.data?.solar_elevator ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <RiParkingBoxLine size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{iconData[4].label}</span>{" "}
          {data?.data?.parking ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <MdBalcony size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{iconData[2].label}</span>{" "}
          {data?.data?.balcony ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <MdOutlinePool size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{iconData[3].label}</span>{" "}
          {data?.data?.pool ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <PiSolarPanel size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{iconData[5].label}</span>{" "}
          {data?.data?.solar_water ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <TbSolarElectricity size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{iconData[6].label}</span>{" "}
          {data?.data?.solar_electricity ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <GiHotSurface size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{iconData[7].label}</span>{" "}
          {data?.data?.terrace ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>



        <Grid size={4} item>
          <PiPark size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{iconData[8].label}</span>{" "}
          {data?.data?.garden ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>
      </Grid>

      {data?.data?.unit_plan && (
        <h3
          style={{
            fontFamily: "Oswald,Cairo, sans-serif",
            marginTop: "50px",
            marginBottom: "20px",
            fontWeight: "bolder",
            direction: direction,
          }}
        >
          {t("drawerUnit.unitplan")}
        </h3>
      )}
      {data?.data?.unit_plan && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            direction: direction,
          }}
        >
          <img
            src={`http://3dfinal.tanaghomtech.com/storage/app/public/${data?.data?.unit_plan}`}
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "8px",
              objectFit: "cover",
            }}
            alt="Unit Plan"
          />
        </div>
      )}
      {data?.videos_count !== 0 && (
        <div className="row" style={{ direction: direction }}>
          <h3
            style={{
              fontFamily: "Oswald,Cairo, sans-serif",
              marginTop: "50px",
              marginBottom: "20px",
              fontWeight: "bolder",
            }}
          >
            {t("drawerUnit.Media")}
          </h3>
          <div style={{ cursor: "pointer" }} onClick={() => { }}>
            <div
              onClick={handleOpen}
              style={{
                backgroundImage: `url(${img2})`,
                width: "200px",
                height: "200px",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                margin: "8px",
                borderRadius: "8px",
                direction: direction,
              }}
            >
              <MdOutlineSlowMotionVideo
                style={{
                  color: "white",
                  margin: "47px",
                  fontSize: "100px",
                  direction: direction,
                }}
              />
              <Modal open={open} onClose={handleClose}>

                <Box
                  sx={{
                    ...style,
                    width: "90%",
                    maxWidth: "1200px",
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    padding: 2,
                    backgroundColor: "#fff",
                  }}
                >
                  <a style={{ cursor: "pointer" }} onClick={(e) => {
                    e.stopPropagation(); // ✅ very important
                    handleClose();
                  }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      fill="#232324"
                      class="bi bi-x-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                    </svg>
                  </a>
                  {/* Main video player */}
                  <Box sx={{ flex: 3 }}>
                    {selectedVideo ? (
                      <ReactPlayer
                        src={selectedVideo}
                        controls
                        width="100%"
                        height="500px"
                      />
                    ) : (
                      <p>No video selected</p>
                    )}
                  </Box>

                  {/* Small video list on the right */}
                  <Box sx={{ flex: 1, overflowY: "auto", maxHeight: "500px" }}>
                    {videoList?.map((video) => (
                      <Box
                        key={video?.id}
                        sx={{
                          marginBottom: "10px",
                          cursor: "pointer",
                          border: selectedVideo === process.env.REACT_APP_IMAGE + video.link ? "2px solid #1976d2" : "1px solid #ccc",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                        onClick={() => handleVideoClick(video)}
                      >
                        <ReactPlayer
                          src={"http://3dfinal.tanaghomtech.com/storage/app/public/" + video.link}
                          controls={false}
                          width="100%"
                          height="100px"
                        />
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Modal>
            </div>
            <h5
              style={{
                fontFamily: "Oswald,Cairo, sans-serif",
                paddingLeft: "8px",
                direction: direction,
              }}
            >
              {t("drawerUnit.ProjectVideos")}
            </h5>
            <p
              style={{
                fontFamily: "Oswald,Cairo, sans-serif",
                paddingLeft: "8px",
                direction: direction,
              }}
            >
              {data?.videos_count} {t("drawerUnit.videos")}
            </p>
          </div>
        </div>
      )}

      {data?.data?.post?.id && (
        <div className="row" style={{ textAlign: "center" }}>

          <div className="col-md-12">
            <div className="circle-container">
              <h1 className="title">{data.data.post.post_reference}</h1>
              <p className="subtitle">{t('drawerUnit.adsnumber')}</p>
            </div>
          </div>
        </div>
      )}

      <h3
        style={{
          fontFamily: "Oswald,Cairo, sans-serif",
          marginTop: "50px",
          marginBottom: "20px",
          fontWeight: "bolder",
          direction: direction,
        }}
      >
        {t("drawerUnit.detailsconn")}
      </h3>
      <div className="row">

        <div
          style={{
            display: "flex",
            alignItems: "center",

            fontWeight: "bolder",
          }}
          className="col-md-2"
        >
          <Avatar
            onClick={handleClick}
            sx={{
              width: "80px",
              height: "80px",
              cursor: "pointer",
              transition: "transform 0.3s ease",
              "&:hover": { transform: "scale(1.05)" },
            }}
            alt={data?.data?.post?.user?.name}
            src={process.env.REACT_APP_IMAGE + data?.data?.post?.user?.image}
          />{" "}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",

            fontWeight: "bolder",
          }}
          className="col-md-10"
        >
          {data?.data?.post?.user?.name}
          {/* <FaMobileAlt
            style={{
              backgroundColor: "#f3efee",
              margin: "5px",
              width: "50px",
              height: "50px",
              padding: "10px",
              borderRadius: "10px",
            }}
          /> */}
        </div>
        {showDiv && (
          <div
            style={{
              maxHeight: showDiv ? "200px" : "0px",
              opacity: showDiv ? 1 : 0,
              overflow: "hidden",
              transition: "max-height 0.5s ease, opacity 0.5s ease",
              // backgroundColor: '#e0e0e0',
              marginTop: "10px",
              padding: showDiv ? "10px" : "0px",
              borderRadius: "8px",
            }}
            className="row"
          >
            <div className="col-md-3">
              {" "}
              <IoIosCall size={22} /> {data?.data?.post?.user?.mobile}
            </div>
            <div className="col-md-3">
              {" "}
              {data?.data?.post.user?.whatsapp ? (
                <RiWhatsappFill size={22} />
              ) : (
                ""
              )}{" "}
              <a
                href={`https://wa.me/${data?.data?.post?.user?.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{textDecoration:"none",color:"#333333"}}
              >
                {data?.data?.post?.user?.whatsapp
                  ? data?.data?.post?.user?.whatsapp
                  : ""}
              </a>

            </div>
            <div className="col-md-3">
              {" "}
              {data?.data?.post?.user?.email ? <TfiEmail size={22} /> : ""}{" "}
              {data?.data?.post?.user?.email ? data?.data?.post?.user?.email : ""}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Drawer2;
